import React from 'react';

import Button from '@/shared/components/button/Button';

import type { MouseEvent, PointerEvent } from 'react';

interface BackButtonProps {
	onClick: (event: MouseEvent<HTMLButtonElement>) => void;
	onPointerDown?: (event: PointerEvent<HTMLButtonElement>) => void;
	small?: boolean;
}

const BackButton = ({ onClick, onPointerDown, small }: BackButtonProps) => (
	<Button
		iconName="icon-arrow-left"
		color="white"
		type="secondary"
		rounded
		onClick={onClick}
		onPointerDown={onPointerDown}
		className="back-button"
		small={small}
	/>
);

export default BackButton;
